var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.634.355a1.461 1.461 0 0 0-.462-.263 1.641 1.641 0 0 0-1.09 0c-.173.061-.33.15-.462.263L8.079 5.07 2.537.355A1.56 1.56 0 0 0 1.53.001C1.153 0 .79.128.523.355a1.128 1.128 0 0 0-.417.857c0 .321.15.63.417.856L7.08 7.645c.132.112.289.202.462.263a1.641 1.641 0 0 0 1.09 0c.172-.061.33-.15.462-.263l6.555-5.577c.543-.461.543-1.239-.014-1.713Z",
    fill: "#58595B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.f6d0c97b.svg";
export { ForwardRef as ReactComponent };